import React from 'react'
import ReviewsComp from '../../components/admin/reviews'
export default function Reviews() {
  return (
    <div>
        <ReviewsComp/>
    </div>
  )
}
